import React from 'react';
import styled from 'styled-components';

import {typeScale} from 'styles/globals';

const Wrapper = styled.div`
	text-align: center;
	line-height: 1.3;
`;

const Count = styled.span`
	display: block;

	font-size: ${typeScale.xxl};
	font-weight: 600;
`;

const BigNumber = ({count, children, ...otherProps}) => (
	<Wrapper {...otherProps}>
		<Count>{count || 0}</Count>
		{children}
	</Wrapper>
);

export default BigNumber;
